import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import StatusPillButtons from "components/Buttons/StatusPillButtons";
import { LinkText } from "components/SocialLinkDropdown/styled";
import {
  CompanyNameCell,
  getFullName,
  getUserPlaceholder,
  renderValue
} from "utils/renderCompanyCell";

const columnHelper = createColumnHelper();

const columns = (onEdit) => {
  const renderName = (row) => {
    const fullName = renderValue(getFullName(row?.creator_user));

    return (
      <CompanyNameCell
        logo={row?.creator_user?.profile_pic || getUserPlaceholder()}
        name={fullName}
        title={fullName}
      />
    );
  };

  const renderInstagramStatus = (status) => {
    switch (status) {
      case "error":
        return "Crawl Failed";
      default:
        return status ? status.charAt(0).toUpperCase() + status.slice(1) : "";
    }
  };

  return [
    columnHelper.accessor("creator_user_id", {
      header: "Creator user ID",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),

    columnHelper.accessor((row) => row.name, {
      id: "name",
      header: "Name",
      size: 200,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => {
        const row = info.row.original;
        return renderName(row);
      }
    }),

    columnHelper.accessor((row) => row.creator_user.phone_number, {
      id: "phone",
      header: "Phone",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => {
        const row = info.row.original.creator_user;
        return <>{`+91 ${renderValue(row?.phone_number)}`}</>;
      }
    }),

    columnHelper.accessor("instagram_handle", {
      header: "IG Handle",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => (
        <>
          {
            <LinkText
              className="link-text-pointer"
              onClick={() =>
                window.open(
                  `https://www.instagram.com/${info.getValue()}`,
                  "_blank"
                )
              }
            >
              {info.getValue()}
            </LinkText>
          }
        </>
      )
    }),

    columnHelper.accessor("instagram_status", {
      header: "IG Status",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(renderInstagramStatus(info.getValue()))}</>
    }),

    columnHelper.accessor("instagram_manual_verification_status", {
      header: "Status",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => {
        const value = info.getValue();
        return <StatusPillButtons status={value} />;
      }
    }),

    columnHelper.display({
      header: "Actions",
      headerClassName: "table-header",
      size: 140,
      enableSorting: false,
      cell: (info) => {
        return (
          <LinkText
            className="link-text-pointer"
            onClick={() => onEdit(info.row.original)}
          >
            View Profile
          </LinkText>
        );
      }
    })
  ];
};

export const completedStatecolumns = [
  columnHelper.accessor("instagram_name", {
    id: "instagram_name",
    header: "IG Name",
    size: 160,
    headerClassName: "table-header",
    cellClassName: "table-cell",
    enableSorting: false,
    cell: (info) => {
      return (
        <div className="truncate-text">{renderValue(info.getValue())}</div>
      );
    }
  }),
  columnHelper.accessor("instagram_followers", {
    id: "instagram_followers",
    header: "IG Followers",
    size: 160,
    headerClassName: "table-header",
    cellClassName: "table-cell",
    enableSorting: false,
    cell: (info) => <>{renderValue(info.getValue())}</>
  })
];

export default columns;
